@if (objectFields) {
  <div
    class="search-result-view-list md-table"
    [class.search-result-view-list--stable]="stableColumns"
    [class.search-result-view-list--frame]="framed"
  >
    <table
      mat-table
      [dataSource]="dataSource"
      [class.mat-elevation-z8]="!framed"
    >
      <caption></caption>

      <ng-container matColumnDef="select" sticky>
        <th
          mat-header-cell
          *matHeaderCellDef
          class="search-result-view-list__select"
        ></th>
        <td
          mat-cell
          *matCellDef="let element"
          class="search-result-view-list__select"
        >
          <div
            class="md-table__checkbox"
            [ngClass]="{'disabled': element.used}"
          >
            <span
              class="checkbox-disabled-tooltip-wrapper"
              [class.cursor-not-allowed]="isCheckboxDisabled(element) && !element.used"
              [matTooltip]="isCheckboxDisabled(element) && !element.used ? ('TRANS__SEARCH_SELECTIONS__TOO_MANY_SELECTED' | translate) : ''"
            >
              <mat-checkbox
                class="white-bg-in-checkbox"
                (click)="select(element, $event)"
                [checked]="isCheckboxSelected(element)"
                [disabled]="isCheckboxDisabled(element)"
              ></mat-checkbox>
            </span>
          </div>
        </td>
      </ng-container>

      <ng-container
        matColumnDef="artifact_name"
        sticky
      >
        <th
          mat-header-cell
          *matHeaderCellDef
          (click)="setOrder(artifactNameField)"
          class="sorting-enabled"
          [ngClass]="{'active': searchContainer.getOrder() === AConst.ARTIFACT_NAME || searchContainer.getOrder() === (AConst.ARTIFACT_NAME + ' desc')}"
        >
          <span>
            {{'TRANS__FIELD__NAME' | translate}}
          </span>

          <i
            class="icon-arrow-up2 sortAsc"
            [ngClass]="{'increasing': searchContainer.getOrder().indexOf('desc') !== -1}"
          ></i>

          <i
            class="icon-arrow-down2 sortDesc"
            [ngClass]="{'decreasing': searchContainer.getOrder().indexOf('desc') === -1}"
          ></i>
        </th>

        <td
          mat-cell
          *matCellDef="let element; index as $index"
          class="locked-column"
        >
          <div class="search-result-view-list__first-col">
            <div
              class="md-table__checkbox"
              [ngClass]="{'disabled': element.used}"
            >
               <span
                 class="checkbox-disabled-tooltip-wrapper"
                 [class.cursor-not-allowed]="isCheckboxDisabled(element) && !element.used"
                 [matTooltip]="isCheckboxDisabled(element) && !element.used ? ('TRANS__SEARCH_SELECTIONS__TOO_MANY_SELECTED' | translate) : ''"
               >
                 <mat-checkbox
                   class="white-bg-in-checkbox"
                   (click)="select(element, $event)"
                   [checked]="isCheckboxSelected(element)"
                   [disabled]="isCheckboxDisabled(element)"
                 ></mat-checkbox>
              </span>
            </div>

            <button
              mat-icon-button
              [style.visibility]="!isExpandable(element) ? 'hidden' : ''"
              [class.hideToggle]="!isExpandable(element) && !element['isLoading']"
              [style.margin-left.px]="element.level > 1 ? (element.level * 10) : 0"
              (click)="treeControl.toggle(element)"
            >
              @if (!element['isLoading']) {
                <mat-icon class="mat-icon-rtl-mirror">
                  {{treeControl.isExpanded(element) ? 'expand_more' : 'chevron_right'}}
                </mat-icon>
              }
              @else {
                <mat-spinner
                  color="accent"
                  diameter="16"
                ></mat-spinner>
              }
            </button>

            <div class="md-table__name bold">
              <a
                [routerLink]="getRouterLink(element)"
                [queryParams]="element['refData']['queryParams']"
                queryParamsHandling="merge"
                (click)="setSearchItemIndex(element['refData'].param['searchItemIndex'])"
                class="table-first-column-list-name"
              >
                <span class="object-url-content">
                  <span class="list-icon-container">
                    <i
                      class="searchIcon object-icon {{element.icon}}"
                      [class.text-blue]="element['meta_type'] === MetaTypes.ADM_EVENT || element['meta_type'] === 'folder'"
                    ></i>
                  </span>

                  <span
                    class="text-link"
                    [innerHTML]="element.name"
                  ></span>
                </span>
              </a>
            </div>
          </div>
        </td>
      </ng-container>

      @for (col of searchContainer.currentPathView.search_view.overview_fields; track $index) {
        <ng-container [matColumnDef]="col.$$fieldColumnName">
          <th
            mat-header-cell
            *matHeaderCellDef
            (click)="setOrder(col)"
            [class.sorting-enabled]="col.isSortable"
            [ngClass]="{'active': col.isSortable && (searchContainer.getOrder() === col.field_name || searchContainer.getOrder() === (col.field_name + ' desc'))}"
          >
            <span>
              {{col.$$fieldTitle}}
            </span>

            @if (col.isSortable) {
              <i
                class="icon-arrow-up2 sortAsc"
                [ngClass]="{'increasing': searchContainer.getOrder().indexOf('desc') !== -1}"
              ></i>

              <i
                class="icon-arrow-down2 sortDesc"
                [ngClass]="{'decreasing': searchContainer.getOrder().indexOf('desc') === -1}"
              ></i>
            }
          </th>

          <td
            mat-cell
            *matCellDef="let element"
          >
            @for (field of getObjectFields(element); track $index) {
              <div title="{{field.title}}">
                @if (col.$$fieldColumnName === field.$$fieldColumnName) {
                  <app-overview-field-value
                    [object]="element.item"
                    [viewName]="searchContainer.searchResultViewName"
                    [overviewField]="field"
                    [metaField]="col"
                  ></app-overview-field-value>
                }
              </div>
            }
          </td>
        </ng-container>
      }

      <ng-container
        [matColumnDef]="'setting'"
        stickyEnd
      >
        <th
          mat-header-cell
          *matHeaderCellDef
          class="search-result-view-list__setting"
        >
          <app-operation-dropdown-menu-for-search-container
            [searchContainer]="searchContainer"
            [operationContainer]="fieldTemplateContainer"
            [operationGroupId]="fieldOperationGroupId"
            (operationPerformed)="onOperationPerformed($event)"
          ></app-operation-dropdown-menu-for-search-container>
        </th>

        <td
          mat-cell
          *matCellDef="let element"
        ></td>
      </ng-container>

      <tr
        mat-header-row
        *matHeaderRowDef="displayedCol; sticky: true"
      ></tr>

      <tr
        mat-row
        *matRowDef="let row; columns: displayedCol;"
      ></tr>
    </table>
  </div>
}
